import React, { FC } from 'react';
import { Card, Grid, makeStyles, Theme, Typography } from '@material-ui/core';

interface AboutDescriptionProps {
  postTitle: string;
  postDescription: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  contentBox: {
    height: '100%',
    padding: theme.spacing(6, 4),
  },
  postTitle: {
    color: theme.palette.primary.dark,
  },
  postDescription: {
    lineHeight: '32px',
    marginTop: theme.spacing(2),
  },
}));

const AboutDescription: FC<AboutDescriptionProps> = ({ postTitle, postDescription }) => {
  const classes = useStyles();

  return (
    <Card className={classes.contentBox}>
      <Typography variant={'h3'} className={classes.postTitle}>
        <span>{postTitle}</span>
      </Typography>
      <Typography className={classes.postDescription}>{postDescription}</Typography>
    </Card>
  );
};

export default AboutDescription;
